export enum itemDefinitionsTypes {
  GET_ITEM_DEFINITIONS = '@@itemDefinitions/GET_ITEM_DEFINITIONS',
  GET_ITEM_DEFINITIONS_SUCCESS = '@@itemDefinitions/GET_ITEM_DEFINITIONS_SUCCESS',
  GET_ITEM_DEFINITIONS_FAIL = '@@itemDefinitions/GET_ITEM_DEFINITIONS_FAIL',

  GET_MILESTONESCONFIG_IV = "@IV/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_IV_SUCCESSS = "@IV/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_IV_FAIL = "@IV/GET_MILESTONECONFIG_FAIL"
}
